module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAApklEQVQoU42QMQrCUBBEZ2IneBvBJvknUNROzC3EImitIoi3SLAU9ALGlDmNoJ1/5CcqCCFmi112eTvDLvEOHfw+rDeD1APwBJijZfecZGeH0CXFwQrk4rP0U6U1w+uSioMhyGMl9LXTiIrNBYSpBYHUKd5BtmtB6uEUbyA6TcDG1v+PgcblexKzARBVvwdbhmlUgCXsDyBvDk/dYmCZg3bHaXZy7QtGcTxldZ+vAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map/route/routePoint.png
// module id = /2xs
// module chunks = 2